// @ts-nocheck

import { type StateType } from '../../../states';
import { type EntitiesPools } from '../../../states/entities/pools';
import Basket from '../states/basket';
import Pool from '../states/pool';
import Selection from '../states/selection';
import { PoolStatuses } from '../types';
import type { GridsPoolState as TypePool } from '../types';

import { getActivePoolsIds, getNavigationActivePoolsIds } from './ui';

export const getPools = (state: StateType): EntitiesPools | null => state.entities.pools || null;

export const getPool = (state: StateType, poolId?: number | null): TypePool | null => {
  const pools = getPools(state);
  return poolId && pools ? pools[poolId] : undefined;
};

export const getActivePools = (state: StateType): EntitiesPools => {
  const pools = getPools(state);
  const poolIds = getActivePoolsIds(state) || [];
  return poolIds.reduce((acc, cur) => {
    if (pools && pools[cur]) {
      acc[cur] = pools[cur];
    }
    return acc;
  }, {});
};

export const getNavigationActivePools = (state: StateType): EntitiesPools => {
  const pools = getPools(state);
  const poolIds = getNavigationActivePoolsIds(state) || [];
  return poolIds.reduce((acc, cur) => {
    if (pools && pools[cur]) {
      acc[cur] = pools[cur];
    }
    return acc;
  }, {});
};

export const getPublicGridsCount = (state: StateType, poolId: number | null): number | null => {
  const pool = getPool(state, poolId);
  return pool?.nbPublicGrids;
};

export const getPublicGridsReferences = (state: StateType, poolId: number | null): Array<string> | null => {
  const pool = getPool(state, poolId);
  return pool?.publicGrids;
};

export const getPoolMatchesIds = (state: StateType, poolId: number | null) => {
  const pool = poolId ? getPool(state, poolId) : null;
  return pool?.matches || [];
};

export const getPoolReports = (state: StateType, { poolId }: { poolId: number }) => {
  const pool = getPool(state, poolId);
  const payouts = Pool.getPoolPayouts(pool);
  const reparts = Pool.getPoolReparts(pool);
  const isTemp = pool && pool.poolStatus === PoolStatuses.LIVE;
  const nbMatches = pool?.matches?.length;

  const finalPayouts = payouts.length === 0 ? reparts : payouts;

  return {
    payouts: finalPayouts,
    nbMatches,
    isTemp,
  };
};

export const getPoolResultSelection = (state: StateType, poolId: number) => {
  const pool = getPool(state, poolId);
  return pool?.strPoolResult || null;
};

export const getPoolView = (state: StateType, { poolId }: { poolId: number }) => {
  const pool = getPool(state, poolId);

  const { isSystem, selections } = state.grids.basket;
  const firstSystemGridAmount = selections[0] ? Selection.getAmount(selections[0]) : 0;

  const collectedAmount = Pool.isCollectedHigherThanGuaranty(pool) ? pool?.netStakes : null;
  const guaranteedAmount = pool?.guaranteedAmount;

  return {
    poolId,
    status: pool?.poolStatus,
    guaranteedAmount,
    collectedAmount,
    strPoolResult: pool?.strPoolResult,
    endDate: pool?.poolEnd,
    isSystem,
    firstSystemGridAmount,
    hasAtLeastOneDoubleOrOneTriple: Basket.hasAtLeastOneDoubleOrOneTriple(selections),
  };
};
